import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function lettersOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^[a-zA-ZçÇğĞıİöÖşŞüÜ\s]*$/.test(control.value);
    return valid ? null : { lettersOnly: true };
  };
}

export function sixDigitNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valid = /^\d{6}$/.test(control.value);
    return valid ? null : { sixDigitNumber: { value: control.value } };
  };
}

export function numberOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valid = /^[0-9]+$/.test(control.value);
    return valid ? null : { numberOnly: { value: control.value } };
  };
}

export function tcKimlikValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = String(control.value ?? '').trim();
    if (!value) {
      return null;
    }

    if (value.length !== 11) {
      return { tcKimlikInvalid: true };
    }

    if (!/^\d{11}$/.test(value)) {
      return { tcKimlikInvalid: true };
    }

    if (value[0] === '0') {
      return { tcKimlikInvalid: true };
    }

    const digits = value.split('').map((c) => Number(c));
    const oddSum = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
    const evenSum = digits[1] + digits[3] + digits[5] + digits[7];
    const digit10 = (((oddSum * 7 - evenSum) % 10) + 10) % 10;

    if (digit10 !== digits[9]) {
      return { tcKimlikInvalid: true };
    }

    const sumFirst10 = digits.slice(0, 10).reduce((acc, d) => acc + d, 0);
    const digit11 = sumFirst10 % 10;

    if (digit11 !== digits[10]) {
      return { tcKimlikInvalid: true };
    }

    return null;
  };
}
